import React, { useEffect } from "react";
import { FylloPesticidesSchedules, FylloSprayTimings, ScreenHeader } from "react-library";
import {   useParams } from "react-router-dom";
import { getAccessToken } from "../../services/common.service";
import { t } from "../../services/locale.service";

const Spray: React.FC = () => {
  const {plotId} = useParams();
  const token = getAccessToken();

  const headerTitle = t("Spray");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  return (
    <div>
      <ScreenHeader screenName={headerTitle} />
      {
        !plotId && <div> {t("No_Plot_Selected")} </div>
      }

      <div className="p-3">
        <FylloSprayTimings plotId={plotId} token={token} />
        <FylloPesticidesSchedules plotId={plotId} token={token} />
      </div>
    </div>
  );
};

export default Spray;